import { createReducer, on } from '@ngrx/store';
import { AuthState, initialAuthState } from './auth.state';
import * as AuthActions from './auth.actions';

export const authReducer = createReducer(
    initialAuthState,

    on(AuthActions.checkAuth, (state): AuthState => ({
        ...state,
        loading: true,
        error: null
    })),

    on(AuthActions.setAccessToken, (state, { accessToken }): AuthState => ({
        ...state,
        accessToken,
        isAuthenticated: accessToken ? true : false
    })),

    on(AuthActions.setActor, (state, { actor }): AuthState => ({
        ...state,
        actor
    })),

    on(AuthActions.checkAuthSuccess, (state, { isAuthenticated }): AuthState => ({
        ...state,
        isAuthenticated,
        loading: false,
        error: null,
        lastAuthCheck: Date.now()
    })),

    on(AuthActions.checkAuthFailure, (state, { error }): AuthState => ({
        ...state,
        isAuthenticated: false,
        accessToken: null,
        actor: null,
        loading: false,
        error,
        lastAuthCheck: Date.now()
    })),

    on(AuthActions.loadCurrentUser, (state): AuthState => ({
        ...state,
        loading: true,
        error: null
    })),

    on(AuthActions.loadCurrentUserSuccess, (state, { user }): AuthState => ({
        ...state,
        user,
        loading: false,
        error: null
    })),

    on(AuthActions.loadCurrentUserFailure, (state, { error }): AuthState => ({
        ...state,
        user: null,
        loading: false,
        error
    })),

    on(AuthActions.signOutSuccess, (state): AuthState => ({
        ...state,
        isAuthenticated: false,
        accessToken: null,
        user: null,
        actor: null,
        loading: false,
        error: null
    })),

    on(AuthActions.clearAuthState, (): AuthState => ({
        isAuthenticated: false,
        accessToken: null,
        user: null,
        actor: null,
        loading: false,
        error: null,
        lastAuthCheck: Date.now()
    }))
);
